import { format } from 'date-fns';
import { MessageCircle } from 'lucide-react';
import { Chat } from '../../types';

interface ChatSidebarProps {
    chats: Chat[];
    activeChatId: string | null;
    onSelectChat: (chatId: string) => void;
    currentUserId: string | null;
}

export function ChatSidebar({ chats, activeChatId, onSelectChat, currentUserId }: ChatSidebarProps) {
    const getOtherParticipant = (chat: Chat) => {
        if (!currentUserId) return { email: 'User' };
        const other = chat.participants?.find((p: any) => p.user_id !== currentUserId);
        return other?.profile || { email: 'User' };
    };

    if (chats.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-full p-6 text-center text-gray-500 bg-white dark:bg-gray-800">
                <MessageCircle className="h-12 w-12 mb-4 text-gray-300" />
                <p>No active chats yet.</p>
            </div>
        );
    }

    return (
        <div className="flex-1 overflow-y-auto bg-white dark:bg-gray-800 border-r border-gray-200 dark:border-gray-700">
            {chats.map(chat => {
                const other = getOtherParticipant(chat);
                const isActive = chat.id === activeChatId;

                return (
                    <div
                        key={chat.id}
                        onClick={() => onSelectChat(chat.id)}
                        className={`p-4 border-b border-gray-100 dark:border-gray-700 cursor-pointer transition-colors ${isActive
                            ? 'bg-rose-50 dark:bg-rose-900/20'
                            : 'hover:bg-gray-50 dark:hover:bg-gray-700'
                            }`}
                    >
                        <div className="flex items-center gap-3">
                            <div className="h-12 w-12 rounded-full bg-rose-100 dark:bg-rose-900/30 flex items-center justify-center overflow-hidden shrink-0">
                                <span className="text-xl font-medium text-rose-600 dark:text-rose-400">
                                    {(other.email || 'U')[0].toUpperCase()}
                                </span>
                            </div>
                            <div className="flex-1 min-w-0">
                                <div className="flex justify-between items-baseline">
                                    <h4 className={`font-medium truncate ${isActive ? 'text-rose-900 dark:text-rose-100' : 'text-gray-900 dark:text-gray-100'}`}>
                                        {other.email || 'User'}
                                    </h4>
                                    <span className="text-xs text-gray-500">
                                        {format(new Date(chat.updated_at), 'MMM d')}
                                    </span>
                                </div>
                                <div className="text-sm text-gray-500 truncate mt-1">
                                    View conversation
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
